// extracted by mini-css-extract-plugin
export default {"player_container":"Player_player_container__3+Pdq"};